module.exports = __webpack_public_path__ + "static/media/wp_2.8564b82e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wp_2.png
// module id = 31
// module chunks = 0